import { useState } from "react";
import {
  Autocomplete,
  AutocompleteRenderInputParams,
  Box,
  Button,
  ListItem,
  ListItemText,
  TextField,
} from "@mui/material";
import Check from "@mui/icons-material/Check";
import { useGetAllUsersQuery } from "app/api/users";
import { useAddUserToCompanyMutation } from "app/api/companies";
import { Company } from "models/Company";
import { User, UserRole } from "features/auth/types/user";
import EmptyMessage from "components/EmptyMessage";

type AddUserFormProps = { company: Company; onClose?: () => void };

const AddUserForm: React.FC<AddUserFormProps> = (props) => {
  const { company, onClose } = props;

  const { data: users, isLoading } = useGetAllUsersQuery({ roles: [UserRole.EXTERNAL_INSTALLER] });

  const [addUserToCompany, { isLoading: isAddingUser }] = useAddUserToCompanyMutation();

  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();

        if (!selectedUser) return;

        addUserToCompany({ companyId: company.id, userId: selectedUser?.id })
          .unwrap()
          .then(onClose);
      }}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "end",
        gap: 1,
        p: 1,
        width: "100%",
        maxWidth: 400,
        marginInline: "auto",
      }}
    >
      <Autocomplete
        value={selectedUser}
        onChange={(event, newValue) => setSelectedUser(newValue as User | null)}
        loading={isLoading}
        disabled={isAddingUser}
        autoSelect
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        sx={{ width: "100%", flexGrow: 1 }}
        renderInput={(params) => (
          <TextField
            {...(params as AutocompleteRenderInputParams)}
            label="Välj installatör"
            variant="filled"
          />
        )}
        options={users ?? []}
        renderOption={(props, option) => (
          <ListItem {...props}>
            <ListItemText
              primary={option.userName}
              secondary={
                option.companyName || <EmptyMessage fontSize="inherit">Inget företag</EmptyMessage>
              }
            />
          </ListItem>
        )}
        getOptionLabel={(option) => option.userName}
      />

      <Button
        type="submit"
        variant="contained"
        disabled={!selectedUser}
        loading={isAddingUser}
        startIcon={<Check />}
      >
        Lägg till
      </Button>
    </Box>
  );
};

export default AddUserForm;
